import { render, staticRenderFns } from "./ListaCasos.vue?vue&type=template&id=45ca9f2c"
import script from "./ListaCasos.vue?vue&type=script&lang=js"
export * from "./ListaCasos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports